import React, { useCallback, useState } from "react";
import PropTypes from "prop-types";
import { TablePagination } from "@material-ui/core";

export const OPCIONES_POR_PAGINA = [10, 25, 50];

export const usePaginacion = (porPaginaInicial = OPCIONES_POR_PAGINA[0]) => {
  const [pagina, setPagina] = useState(0);
  const [porPagina, setPorPagina] = useState(porPaginaInicial);

  const onCambiarPorPagina = useCallback((nuevo) => {
    setPorPagina(nuevo);
    setPagina(0);
  }, []);
  const reiniciar = useCallback(() => setPagina(0), []);

  return {
    pagina,
    porPagina,
    onCambiarPagina: setPagina,
    onCambiarPorPagina,
    reiniciar,
  };
};

const Paginacion = ({
  total,
  pagina,
  porPagina,
  opciones,
  onCambiarPagina,
  onCambiarPorPagina,
}) => (
  <TablePagination
    component="div"
    count={total}
    page={pagina}
    rowsPerPage={porPagina}
    rowsPerPageOptions={opciones}
    onPageChange={(_evento, nueva) => onCambiarPagina(nueva)}
    onRowsPerPageChange={({ target }) =>
      onCambiarPorPagina(Number(target.value))
    }
    labelRowsPerPage="Registros por página"
    labelDisplayedRows={({ from, to, count }) => `${from}-${to} de ${count}`}
    backIconButtonText="Página anterior"
    nextIconButtonText="Página siguiente"
  />
);

Paginacion.propTypes = {
  total: PropTypes.number.isRequired,
  pagina: PropTypes.number.isRequired,
  porPagina: PropTypes.number.isRequired,
  opciones: PropTypes.arrayOf(PropTypes.number),
  onCambiarPagina: PropTypes.func.isRequired,
  onCambiarPorPagina: PropTypes.func.isRequired,
};

Paginacion.defaultProps = {
  opciones: OPCIONES_POR_PAGINA,
};

export default Paginacion;
